<template>
  <div ref="pageView" class="all-content container-view" v-loading="loading">
    <!-- title -->
    <section class="title clearfix fixed-view">
      <div class="title-name fl">企业监控</div>
      <div class="oprate">
        <el-checkbox v-model="checked" @change="autoRefreshEvent"
          >自动刷新
        </el-checkbox>
        <i class="e6-icon-refresh_line" @click="getInitData"></i>
        <span class="refresh-icon" @click="getInitData">手动刷新</span>
        <i
          class="search-icon e6-icon-search_line"
          @click="handleSearchFormVisible"
        ></i>
      </div>
    </section>
    <!-- title end -->
    <!-- 查询条件 start -->
    <section class="search fixed-view" v-show="searchFormVisible">
      <el-form class="searchForm" ref="searchForm" :model="searchForm">
        <el-form-item class="search-item fl" prop="companyIds">
          <el-select
            v-model="searchForm.companyIds"
            placeholder="企业名称"
            filterable
            multiple
            collapse-tags
            clearable
            class="select-limit"
          >
            <el-option
              v-for="item in allComparys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-item fl" prop="managerModel">
          <dict-select
            v-model="searchForm.managerModel"
            placeholder="经营领域"
            :pkey="'manager_model'"
          ></dict-select>
        </el-form-item>
        <el-form-item class="search-item fl">
          <el-button type="primary" @click="handleQuery()">查询</el-button>
        </el-form-item>
        <el-form-item class="search-item fl">
          <el-button type="primary" plain @click="handleReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </section>
    <!-- 查询条件 end -->
    <!-- 企业信息 start -->
    <section
      class="content"
      :style="`height: ${resizeViewHeight - 15 - 10 - 80}px`"
      ref="companyInfo"
    >
      <div class="all-info-wrapper" element-loading-text="数据加载中">
        <div
          class="company"
          v-for="compary in comparyList"
          :key="compary.companyId"
        >
          <div class="company-title clearfix">
            <div class="company-title-info fl">
              <i class="company-icon"></i>
              <span class="company-name">{{ compary.companyName }}</span>
            </div>
          </div>
          <div class="card-info clearfix">
            <el-card class="box-card fl">
              <div slot="header" class="clearfix card-title total-color">
                <span>监测点总数</span>
              </div>
              <div class="card-body clearfix">
                <div class="fl all-count">
                  <span>{{ compary.allMonitPointVO.monitorPointCount }}</span>
                </div>
                <div class="fr">
                  <div class="icons">
                    <i class="e6-icon-track-run_fill i-car" title="车辆"></i>
                    <i
                      class="e6-icon-warehouse_fill i-storage"
                      title="仓库"
                    ></i>
                    <i class="e6-icon-store_fill i-store" title="门店"></i>
                    <i
                      class="e6-icon-front-bin_fill i-lead-storage"
                      title="前置仓"
                    ></i>
                  </div>
                  <div class="count-box">
                    <!-- 车 可跳转到车辆监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.allMonitPointVO.vehicleMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterVehicleList',
                          query: {
                            companyId: compary.companyId
                          }
                        }"
                      >
                        {{ compary.allMonitPointVO.vehicleMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.allMonitPointVO.vehicleMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.allMonitPointVO.storageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{ compary.allMonitPointVO.storageMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.allMonitPointVO.storageMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 门店 可跳转到门店监控 -->
                    <div class="count">
                      <router-link
                        v-if="compary.allMonitPointVO.storeMonitorPointNum > 0"
                        :to="{
                          path: '/monitCenterStoreList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{ compary.allMonitPointVO.storeMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.allMonitPointVO.storeMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 前置仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.allMonitPointVO.leadStorageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{ compary.allMonitPointVO.leadStorageMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.allMonitPointVO.leadStorageMonitorPointNum
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
            <el-card class="box-card fl">
              <div slot="header" class="clearfix card-title normal-color">
                <span>正常监测点总数</span>
              </div>
              <div class="card-body clearfix">
                <div class="fl all-count">
                  <span>{{
                    compary.normalMonitPointVO.monitorPointCount
                  }}</span>
                </div>
                <div class="fr">
                  <div class="icons">
                    <i class="e6-icon-track-run_fill i-car" title="车辆"></i>
                    <i
                      class="e6-icon-warehouse_fill i-storage"
                      title="仓库"
                    ></i>
                    <i class="e6-icon-store_fill i-store" title="门店"></i>
                    <i
                      class="e6-icon-front-bin_fill i-lead-storage"
                      title="前置仓"
                    ></i>
                  </div>
                  <div class="count-box">
                    <!-- 车 可跳转到车辆监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.normalMonitPointVO.vehicleMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterVehicleList',
                          query: {
                            companyId: compary.companyId
                          }
                        }"
                      >
                        {{ compary.normalMonitPointVO.vehicleMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.normalMonitPointVO.vehicleMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.normalMonitPointVO.storageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '1'
                          }
                        }"
                      >
                        {{ compary.normalMonitPointVO.storageMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.normalMonitPointVO.storageMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 门店 可跳转到门店监控 -->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.normalMonitPointVO.storeMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStoreList',
                          query: {
                            companyId: compary.companyId,
                            status: '1'
                          }
                        }"
                      >
                        {{ compary.normalMonitPointVO.storeMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.normalMonitPointVO.storeMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 前置仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.normalMonitPointVO
                            .leadStorageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{
                          compary.normalMonitPointVO.leadStorageMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.normalMonitPointVO.leadStorageMonitorPointNum
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
            <el-card class="box-card fl">
              <div slot="header" class="clearfix card-title alarm-color">
                <span>报警监测点总数</span>
              </div>
              <div class="card-body clearfix">
                <div class="fl all-count">
                  <span>{{ compary.alarmMonitPointVO.monitorPointCount }}</span>
                </div>
                <div class="fr">
                  <div class="icons">
                    <i class="e6-icon-track-run_fill i-car" title="车辆"></i>
                    <i
                      class="e6-icon-warehouse_fill i-storage"
                      title="仓库"
                    ></i>
                    <i class="e6-icon-store_fill i-store" title="门店"></i>
                    <i
                      class="e6-icon-front-bin_fill i-lead-storage"
                      title="前置仓"
                    ></i>
                  </div>
                  <div class="count-box">
                    <!-- 车 可跳转到车辆监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.alarmMonitPointVO.vehicleMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterVehicleList',
                          query: {
                            companyId: compary.companyId
                          }
                        }"
                      >
                        {{ compary.alarmMonitPointVO.vehicleMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.alarmMonitPointVO.vehicleMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.alarmMonitPointVO.storageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '2'
                          }
                        }"
                      >
                        {{ compary.alarmMonitPointVO.storageMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.alarmMonitPointVO.storageMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 门店 可跳转到门店监控 -->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.alarmMonitPointVO.storeMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStoreList',
                          query: {
                            companyId: compary.companyId,
                            status: '2'
                          }
                        }"
                      >
                        {{ compary.alarmMonitPointVO.storeMonitorPointNum }}
                      </router-link>
                      <span v-else>{{
                        compary.alarmMonitPointVO.storeMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 前置仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.alarmMonitPointVO.leadStorageMonitorPointNum >
                            0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{
                          compary.alarmMonitPointVO.leadStorageMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.alarmMonitPointVO.leadStorageMonitorPointNum
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
            <el-card class="box-card fl">
              <div slot="header" class="clearfix card-title drop-color">
                <span>掉线监测点总数</span>
              </div>
              <div class="card-body clearfix">
                <div class="fl all-count">
                  <span>{{
                    compary.lostConnectionMonitPointVO.monitorPointCount
                  }}</span>
                </div>
                <div class="fr every-count">
                  <div class="icons">
                    <i class="e6-icon-track-run_fill i-car" title="车辆"></i>
                    <i
                      class="e6-icon-warehouse_fill i-storage"
                      title="仓库"
                    ></i>
                    <i class="e6-icon-store_fill i-store" title="门店"></i>
                    <i
                      class="e6-icon-front-bin_fill i-lead-storage"
                      title="前置仓"
                    ></i>
                  </div>
                  <div class="count-box">
                    <!-- 车 可跳转到车辆监控compary.companyId-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.lostConnectionMonitPointVO
                            .vehicleMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterVehicleList',
                          query: {
                            companyId: compary.companyId
                          }
                        }"
                      >
                        {{
                          compary.lostConnectionMonitPointVO
                            .vehicleMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.lostConnectionMonitPointVO
                          .vehicleMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.lostConnectionMonitPointVO
                            .storageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '3'
                          }
                        }"
                      >
                        {{
                          compary.lostConnectionMonitPointVO
                            .storageMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.lostConnectionMonitPointVO
                          .storageMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 门店 可跳转到门店监控 -->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.lostConnectionMonitPointVO
                            .storeMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStoreList',
                          query: {
                            companyId: compary.companyId,
                            status: '3'
                          }
                        }"
                      >
                        {{
                          compary.lostConnectionMonitPointVO
                            .storeMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.lostConnectionMonitPointVO.storeMonitorPointNum
                      }}</span>
                    </div>
                    <!-- 前置仓 可跳转到仓库监控-->
                    <div class="count">
                      <router-link
                        v-if="
                          compary.lostConnectionMonitPointVO
                            .leadStorageMonitorPointNum > 0
                        "
                        :to="{
                          path: '/monitCenterStorageList',
                          query: {
                            companyId: compary.companyId,
                            status: '0'
                          }
                        }"
                      >
                        {{
                          compary.lostConnectionMonitPointVO
                            .leadStorageMonitorPointNum
                        }}
                      </router-link>
                      <span v-else>{{
                        compary.lostConnectionMonitPointVO
                          .leadStorageMonitorPointNum
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </section>
    <!-- 翻页 -->
    <section class="pagination-section">
      <e6-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :pageSize.sync="searchForm.pageSize"
        :pageSizes="[10, 20, 50]"
        :currentPage.sync="searchForm.curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 企业信息 end -->
  </div>
</template>

<script>
import resizeListener from "_private/mixins/resizeListener";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import { FetchComparyListByPage } from "../../../api/monitorCenter/storageList";

export default {
  mixins: [resizeListener],
  data() {
    return {
      loading: false,
      autoRefresh: true, //自动刷新是否勾选
      checked: true,
      timeOut: "", //自动刷新 定时器
      searchFormVisible: false, //查询条件是否展开
      searchForm: {
        pageSize: 20,
        curPage: 1,
        companyIds: [], //企业名称
        managerModel: "" //经营领域
      },
      allComparys: [], //所有企业名称
      total: 0,
      comparyList: []
    };
  },
  created() {
    this.initAllComparys();
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    //监听数据
    this.getListIng();
  },
  destroyed: function() {
    clearTimeout(this.timeOut);
    this.timeOut = "";
  },
  methods: {
    //查询条件显示隐藏
    handleSearchFormVisible() {
      this.searchFormVisible = !this.searchFormVisible;
      this.$nextTick(this.resizeListener);
    },
    /**
     *  初始化企业
     */
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //查询
    handleQuery() {
      this.searchForm.curPage = 1;
      this.getInitData();
    },
    //重置
    handleReset() {
      this.$refs["searchForm"].resetFields();
    },
    //获取页面数据
    getInitData() {
      this.loading = true;
      FetchComparyListByPage(this.searchForm)
        .then(res => {
          let comparyList = [];
          if (res.code === 1 && Array.isArray(res.result.data)) {
            comparyList = res.result.data;
          }
          this.comparyList = comparyList;
          this.total = res.result.totalRecords;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //监听数据
    getListIng() {
      let _this = this;
      //判断是否自动刷新数据
      if (this.autoRefresh) {
        this.getInitData(); //请求的函数
        this.timeOut = setTimeout(() => {
          _this.getListIng();
        }, 60 * 1000);
      }
    },
    //自动刷新
    autoRefreshEvent(checked) {
      this.autoRefresh = checked;
      if (checked) {
        //监听数据
        this.getListIng();
      } else {
        //清空定时器
        clearTimeout(this.timeOut);
        this.timeOut = "";
      }
    },
    // 翻页
    handleCurrentChange(e) {
      this.searchForm.curPage = e;
      this.getInitData();
      this.$refs.companyInfo.scrollTop = 0; //滚动条回到顶部
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.searchForm.curPage = 1;
      this.pageSize = e;
      this.getInitData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/compary-monitor.scss";
@import "../../../assets/iconFont/iconfont.css";
</style>
